import { GebouweenheidFunctieEnum } from '@/domain/interface/melding/GebouweenheidFunctieEnum';
import { GemeenteResponse } from '@/domain/interface/intern/locatie/Gementen/GemeenteType';

export class Gebouw {
  volledigAdres?: string;
  straatnaamEnHuisnummer?: string;
  vbrGebouweenheidAdres?: string;
  vbrAdresId?: string;
  vbrGebouwOnbestaand?: boolean;
  vbrGebouwId?: string;
  vbrGebouweenheidOnbestaand?: boolean;
  vbrGebouweenheidId?: string;
  vbrStraat?: string;
  vbrNummer?: string;
  vbrBus?: string;
  vbrPostcode?: string;
  vbrGemeente?: GemeenteResponse | string;
  straat?: string;
  nummer?: string;
  bus?: string;
  postcode?: string;
  gemeente?: string;
  homoniem?: string;
  detail?: string;
  functie?: GebouweenheidFunctieEnum;

  constructor(gebouw?: Gebouw) {
    this.vbrAdresId = gebouw?.vbrAdresId;
    this.volledigAdres = gebouw?.volledigAdres;
    this.straatnaamEnHuisnummer = gebouw?.straatnaamEnHuisnummer;
    this.vbrGebouweenheidAdres = gebouw?.vbrGebouweenheidAdres;
    this.vbrGebouwOnbestaand = gebouw?.vbrGebouwOnbestaand;
    if (!gebouw?.vbrGebouwOnbestaand && !!gebouw?.vbrGebouwId) {
      this.vbrGebouwId = gebouw?.vbrGebouwId;
    }

    this.vbrGebouweenheidOnbestaand = gebouw?.vbrGebouweenheidOnbestaand;
    if (!gebouw?.vbrGebouweenheidOnbestaand && !!gebouw?.vbrGebouweenheidId) {
      this.vbrGebouweenheidId = gebouw?.vbrGebouweenheidId;
    }

    this.vbrStraat = gebouw?.vbrStraat;
    this.vbrNummer = gebouw?.vbrNummer;
    this.vbrBus = gebouw?.vbrBus;
    this.vbrPostcode = gebouw?.vbrPostcode;
    this.vbrGemeente = gebouw?.vbrGemeente;
    this.homoniem = gebouw?.homoniem;
    this.detail = gebouw?.detail;
    this.functie = gebouw?.functie;

    this.gemeente = gebouw?.gemeente;
    this.postcode = gebouw?.postcode;
    this.straat = gebouw?.straat;
    this.nummer = gebouw?.nummer;
    this.bus = gebouw?.bus;
  }

  isVbrGebouwOnbestaand() {
    return this.vbrGebouwOnbestaand;
  }

  isVbrGebouweenheidOnbestaand() {
    return this.vbrGebouweenheidOnbestaand;
  }
}
